module.exports = __webpack_public_path__ + "img/menuTopLogo.194f60d6.png";